<template>
  <div v-if="loaded" :style="fontFamily">
    <Navbar />
    <div class="margin-top-main" @click="closeCart(!isOpenShoppingCart)">
      <slot></slot>
    </div>
    <Footer v-if="partner.footer"/>
  </div>
</template>

<script>
import Partner from "../models/Partner"
import Themes from "../plugins/themes"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import {mapActions, mapGetters} from "vuex"
//https://www.telerik.com/blogs/passing-variables-to-css-on-a-vue-component

export default {
  name: "ChuspicLayout",
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
      partner: new Partner(),
      loaded: false
    }
  },
  mounted() {
    this.getTheme()
  },
  methods: {
    ...mapActions("Web", ["closeShoppingCart", "openShoppingCart"]),
    closeCart(state) {
      if (!state)
        this.closeShoppingCart()
    },
    async getTheme() {
      const partner = await this.partner.fetch()
      this.partner = new Partner(partner)
      this.setTheme()
      this.setPartner()
    },
    setPartner() {
      this.$nextTick(() => {
        this.$root.$emit('setPartner', this.partner)
      });
    },
    setTheme() {
      if(this.partner.theme == "custom") {
        this.$vuetify.theme.themes.light = this.partner.colors
      } else {
        this.$vuetify.theme.themes.light = Themes[this.partner.theme]
      }
      this.loaded = true
    }
  },
  computed: {
    ...mapGetters('Web', ['isOpenShoppingCart']),
    fontFamily() {
      return {
        "--app-font": this.partner.font(),
        "--app-font-bold": this.partner.fontBold(),
        "--app-font-light": this.partner.fontLight()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../scss/font";
  @import "../scss/variables";
  @import "../scss/main";
  @import "../scss/responsive";
  .margin-top-main {
    margin-top: 72px;
  }

  @media (max-width: 768px) {
    .margin-top-main {
      margin-top: 61px;
    }
  }
</style>
